import { SVGAttributes } from 'react';
import { Keys } from '../../../../patient-types';
import BodySelectButton from './BodySelectButton';

const DentalUpperButtons = ({
  selectedKeys,
  ...props
}: SVGAttributes<SVGElement> & {
  selectedKeys: Keys;
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={315} height={316} fill='none' {...props}>
      <path
        fill='#F2F4FC'
        d='M13.5 312.107 18 312l6 .5 10.5 2.5 6.5-.5 5-2.5 3-5 1-4.5 1.5-4.5 3.67-8 .33-4.5-1-5-2-3.5-4-3.5-11.615-5.382 12.349-3.893 4.542-4.542.649-5.19 1.297-6.489 4.542-7.786 1.298-7.137-1.947-5.84-3.893-6.488-5.388-4.8L57.5 208l2.5-6 3.5-11.5 3-10-.437-4.5-1.563-5.5-3-4-7.5-3-3-3-1.248-2.8 5.243-1.748 11.068-5.825 4.077-6.408.583-6.99-2.33-6.99-4.142-3.496L52 119.5l5.5-2.577 4.485-.583 4.078-2.912 4.014-4.078 1.811-9.903-1.811-5.243-4.014-5.242-6.408-5.243 1.748-2.33 3.495-.583h13.398l4.66-1.165 4.66-1.747 2.913-4.078V70.32l-.583-8.738-1.747-6.99 12.233 4.077 5.825.583 5.243-3.495 2.33-5.243V44.69l-.583-10.486 3.496 2.33 4.66 6.99 5.243 4.66 5.242 3.496 5.826.582 6.407-1.747 4.661-3.495 3.495-5.826 1.747-5.825 3.496-13.398-.647-15.146-2.849-2.33L140.044 1l-12.233 1.165-13.398 4.078-5.826 5.825-1.747 3.495h-9.903L79.46 21.388l-5.243 4.078-3.495 6.408-1.748 4.078h-2.912l-6.408.582-6.408 2.33-7.573 2.913-3.495 3.495-1.748 4.078-.582 5.242-1.748 7.573.583 4.66 2.913 6.408-5.243 1.748-9.903 4.66-5.89 4.078-3.43 6.99.582 5.825 2.849 10.486 4.66 8.155 3.559 1.748-3.495 1.748-6.77 4.66-5.463 3.495-2.33 6.99 2.912 9.321 2.913 6.407L18.5 154.5l-4.5 2-3.5 2.5-3.161 4.404L5 171l.762 11v5L5 191.5v5l1.5 4.5 3.803 6 5.84 3.372-5.84 1.946-4.541 2.595-3.893 4.542-.65 4.542 1.298 5.84v8.435l.65 7.786 1.297 8.435 5.84 5.839 6.585 3.761-5.19 1.297-3.894 3.893L5.5 271.5l-3 6-1 5 1.115 6.897L2.5 292.5 2 300l2 5.5 3.157 4.012 6.343 2.595Z'
      />
      <path
        fill='#F2F4FC'
        d='M303.153 312.107h-6.488l-8.435 1.298L277.848 316l-6.488-1.947-4.542-6.488-4.542-10.381-3.244-7.138.649-7.786 4.542-7.786 13.744-6.356-12.349-3.893-4.542-4.542-.649-5.19-1.298-6.489-4.542-7.786-1.297-7.137 1.946-5.84 3.893-6.488 5.388-4.8-5.019-5.832-3.893-5.84-3.244-10.381-3.244-9.733-.649-6.488.649-5.84 3.893-5.84 9.733-5.839 2.357-2.46-5.243-1.748-11.068-5.825-4.078-6.408-.582-6.99 2.33-6.99 4.141-3.496 9.257-6.99-8.156-1.748-2.912-2.005-3.289-3.5-2.5-4-1-5.5 2-8.5 5.954-7 7.546-5-3.5-1.5h-14.5l-6-.5-6-3-2.595-5.5-.405-6 1-4.5 2-6.5-6 2.5-7.08 1.67-5.826.583-5.242-3.495L202.5 53l-1.478-8.31.582-10.486-3.495 2.33-4.66 6.99-5.243 4.66-5.243 3.496-5.825.582L170 50.5l-4.5-3.5-3.5-5.5-1.5-4.966-3.168-14.563L157 13l.5-4.5L160 4l8.5-2 8-1 10.541 1.165L201 7l4.5 5.5.5 5 4-1 7.915-.937 17.476 5.825 5.242 4.078 3.496 6.408L246 34.5h3.954l5.243.5 5.303 2 7 3.5 4.5 2 2.42 6.85L275.5 54l1.5 9.5-1.5 7L272 74l11 4 8.5 4 2.5 2.5 2.5 3.5v8.5l-2 10-5.5 7.5-2.929 2.923L290.5 119l3.5 2.5 7 4.5 3.129 7.816L303 140.5l-1.5 4-4.5 7.5v2.5l4 1.5 3 2.5 3.513 4.904 2.595 7.137L309.5 178l-1 5 1.5 8.5v5l-1.5 4.5-3.952 6-5.839 3.372 5.839 1.946 4.542 2.595 3.893 4.542.649 4.542-1.298 5.84v8.435l-.649 7.786-1.297 8.435-5.84 5.839-6.586 3.761 5.191 1.297 3.893 3.893 3.244 4.542 2.596 6.489.649 5.19-1.298 3.893-.649 5.191v9.733l-3.893 5.191-4.542 2.595Z'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M113.828 33.905c4.41 3.32 6.15 9.018 10.511 12.393 3.224 2.504 6.094 5.661 10.516 5.923 9.282.548 15.876-4.279 18.4-13.465 1.267-4.609 1.163-9.561 2.956-14.043M229.5 53.3c-5.23 3.45-11.336 5.066-17.642 5.873-6.809.874-10.793-5.577-10.647-13.635.05-2.738.35-5.407.796-8.038M263.261 77.894c13.258-4.773 16.374-8.524 11.508-26.87-1.031-3.897-.39-8.238-5.275-10.01-5.406-1.96-10.572-4.938-16.116-6.046-4.346-.865-8.505 1.437-11.406 5.51a130.35 130.35 0 0 1-9.308 11.593'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M271.469 74.398c6.595.738 12.258 3.921 18.166 6.742 5.573 2.661 7.498 6.939 7.037 12.383-.58 6.853-1.219 13.73-6.499 19.249-4.198 4.394-8.676 6.182-14.578 5.862-5.143-.276-10.267-1.235-15.517-.209-6.153 1.205-13.729-4.031-16.025-8.401-3.247-6.176-2.637-12.395 1.537-18.117 3.557-4.88 7.827-8.567 13.471-10.626M200.359 34.717c-4.134 3.512-6.198 8.852-10.539 12.156-3.166 2.404-6.125 5.132-10.508 5.352-7.903.398-15.294-2.306-18.15-13.342-2.337-9.03-4.834-18.285-4.097-27.987.317-4.111 2.009-6.913 5.443-7.775 5.12-1.285 10.539-2.392 15.738-2.062 7.02.447 13.93 2.465 20.53 5.114 5.284 2.123 7.994 7.103 6.819 12.67-1.128 5.326-2.67 10.534-3.721 15.874M50 159.5c.461.467 3.58 3.715 4.128 3.854 11.897 2.988 14.734 12.702 10.212 24.641-1.384 3.653-2.998 7.333-3.599 11.146-.665 4.232-2.135 7.858-4.768 11.114-3.224 3.985-8.008 6.892-12.412 5.278-3.823-1.406-8.175-2.145-12.061-3.033M295.887 209.702c-8.373 1.357-16.585 2.859-24.663 5.83-4.404 1.615-9.188-1.292-12.412-5.278-2.633-3.255-4.103-6.881-4.768-11.113-.601-3.814-2.215-7.494-3.599-11.146-4.522-11.94-1.684-21.654 10.213-24.641.547-.14.938-.885 1.399-1.352M19.155 263.605c-9.166-.746-15.957-7.848-16.187-17.154-.167-6.678-.494-13.329-1.417-19.953-1.217-8.764 5.852-13.94 13.426-16.258 4.372-1.34 8.056 1.138 12.074 1.792'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M295.63 263.605c9.166-.746 15.957-7.848 16.188-17.154.166-6.678.493-13.329 1.416-19.953 1.217-8.764-5.852-13.94-13.426-16.258-4.371-1.34-8.056 1.138-12.074 1.792M16.893 263.858c-7.911 2.495-12.535 8.03-15.136 15.754-1.374 4.071.928 7.702.675 11.634-.112 1.802.215 3.642-.08 5.567-1.271 8.341 5.374 16.027 13.822 15.121 5.697-.612 10.653 1.325 15.748 2.633 9 2.312 15.958-1.308 17.561-10.357.51-2.88 1.277-5.503 2.886-7.863 5.873-8.609 3.572-18.586-5.589-23.654-3.02-1.674-6.249-2.977-9.242-4.694-4.495-2.569-9.435-2.826-14.39-3.229M297.892 263.858c7.912 2.495 12.535 8.03 15.137 15.754 1.373 4.071-.928 7.702-.676 11.634.112 1.802-.215 3.642.08 5.567 1.271 8.341-5.374 16.027-13.822 15.121-5.697-.612-10.653 1.325-15.748 2.633-9.001 2.312-15.957-1.308-17.561-10.357-.51-2.88-1.277-5.503-2.886-7.863-5.873-8.609-3.572-18.586 5.589-23.654 3.02-1.674 6.249-2.977 9.242-4.694 4.495-2.569 9.435-2.826 14.391-3.229M46.559 76.728c2.946 2.006 5.648 4.234 9.293 5.19 5.479 1.43 9.413 5.405 12.808 10.008 7.79 10.578.17 23.219-9.339 24.896-1.612.285-3.218.605-4.821.944M61.086 81.388c1.633-1.32 3.4-.633 5.246-.663 6.327-.096 12.776 1.195 18.945-1.823 3.576-1.75 5.294-4.04 5.21-7.852-.05-2.24.14-4.493-.043-6.716-.328-3.956-1.05-7.685-4.651-10.392-4.08-3.072-7.487-6.675-10.159-11.24-4.013-6.855-10.292-8.247-18.228-5.271-1.7.64-3.485 1.07-5.24 1.566-6.691 1.9-11.312 5.467-12.162 12.913-.51 4.482-2.665 8.647-1.627 13.481.456 2.136 1.09 3.938 2.307 5.414M53.472 219.08c5.476 4.441 7.52 10.191 7.032 17.175-.22 3.143-.928 5.879-2.848 8.357-1.68 2.167-3.133 4.403-2.822 7.418.74 7.058-1.384 10.143-10.186 13.892M261.313 219.08c-5.476 4.441-7.52 10.191-7.032 17.175.22 3.143.928 5.879 2.849 8.357 1.678 2.167 3.132 4.403 2.821 7.418-.74 7.058 1.384 10.143 10.186 13.892M37.476 156.799c-5.745-3.116-11.72-3.121-17.658-2.553-7.938.751-14.643 9.253-14.793 17.969-.048 2.778-.14 5.53.681 8.405.773 2.703 0 5.803-.595 8.791-1.304 6.522.756 12.449 4.961 17.604M277.309 156.799c5.745-3.116 11.72-3.121 17.658-2.553 7.938.751 14.643 9.253 14.793 17.969.048 2.778.14 5.53-.681 8.405-.772 2.703 0 5.803.595 8.791 1.304 6.522-.756 12.449-4.961 17.604'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M16.754 149.922c-2.63-5.866-5.938-11.502-5.389-18.312.21-2.642.87-4.91 3.272-6.247 4.851-2.709 9.11-6.343 14.37-8.442 4.895-1.953 9.562-2.673 14.457 0 2.142 1.173 4.586 2.498 6.907 2.534 6.864.115 10.697 4.898 15.537 8.412 7.358 5.346 6 18.445-2.148 23.706-7.624 4.919-15.377 7.274-23.26 6.595M43.921 73.233c-7.343.44-13.51 3.973-19.732 7.556-4.681 2.697-7.99 8.291-6.831 13.634 1.49 6.877 2.79 13.905 7.392 19.587M106.836 16.146c2.166-5.758 6.033-10.08 11.634-11.503 7.9-2.013 15.654-4.726 24.267-3.193 4.939.88 9.51 1.522 13.263 4.91M256.161 122.166c-1.958 1.551-3.872 3.155-5.879 4.635-9.962 7.336-6.299 19.976 2.569 24.956 5.836 3.275 11.913 5.046 18.262 6.526'
      />
      <path
        stroke='#3455FC'
        strokeDasharray='5 5'
        strokeLinecap='round'
        strokeWidth={1.5}
        d='M69.555 35.397c1.503-11.485 10.821-14.48 20.079-17.493 2.957-.965 5.963-1.78 8.976-2.579 5.438-1.44 10.302 1.763 11.109 7.2.232 1.56.348 3.268 1.093 4.608 3.545 6.371 2.83 13.361 3.007 20.12.269 10.104-6.331 14.147-16.303 10.902-2.265-.737-4.3-2.087-6.516-2.937M284.5 117.5c4.5-.5 7.664 3.266 14.656 7.132 4.649 2.568 5.839 10.625 3.208 17.632-1.068 2.846-4.125 7.45-5.364 10.236M245.473 34.786c-.437-10.883-9.566-13.001-17.143-16.34-3.223-1.421-6.877-2.16-10.339-3.064-3.366-.88-7.044-.416-9.8 2.422M227 57c-.596 1.412-1.562 3.93-1.888 5.338-1.727 7.434-.236 17.336 10.892 18.077 4.727.319 12.775.79 17.496 0'
      />

      <BodySelectButton
        id='o-tooth16'
        selectedKeys={selectedKeys}
        cx={287}
        cy={290}
        r={12}
        d='M283.004 290h8M287 286.001v8'
      />

      <BodySelectButton
        id='o-tooth15'
        selectedKeys={selectedKeys}
        cx={285}
        cy={237}
        r={12}
        d='M281.004 237h8M285 233.001v8'
      />

      <BodySelectButton
        id='o-tooth14'
        selectedKeys={selectedKeys}
        cx={281}
        cy={184}
        r={12}
        d='M277.004 184h8M281 180.001v8'
      />

      <BodySelectButton
        id='o-tooth13'
        selectedKeys={selectedKeys}
        cx={277}
        cy={135}
        r={12}
        d='M273.004 135h8M277 131.001v8'
      />

      <BodySelectButton
        id='o-tooth12'
        selectedKeys={selectedKeys}
        cx={271}
        cy={97}
        r={12}
        d='M267.004 97h8M271 93.001v8'
      />

      <BodySelectButton
        id='o-tooth11'
        selectedKeys={selectedKeys}
        cx={250}
        cy={60}
        r={12}
        d='M246.004 60h8M250 56.001v8'
      />

      <BodySelectButton
        id='o-tooth10'
        selectedKeys={selectedKeys}
        cx={215}
        cy={36}
        r={12}
        d='M211.004 36h8M215 32.001v8'
      />

      <BodySelectButton
        id='o-tooth9'
        selectedKeys={selectedKeys}
        cx={180}
        cy={26}
        r={12}
        d='M176.004 26h8M180 22.001v8'
      />

      <BodySelectButton
        id='o-tooth8'
        selectedKeys={selectedKeys}
        cx={135}
        cy={24}
        r={12}
        d='M131.004 24h8M135 20.001v8'
      />

      <BodySelectButton
        id='o-tooth7'
        selectedKeys={selectedKeys}
        cx={98}
        cy={37}
        r={12}
        d='M94.004 37h8M98 33.001v8'
      />

      <BodySelectButton
        id='o-tooth6'
        selectedKeys={selectedKeys}
        cx={65}
        cy={59}
        r={12}
        d='M61.004 59h8M65 55.001v8'
      />

      <BodySelectButton
        id='o-tooth5'
        selectedKeys={selectedKeys}
        cx={41}
        cy={97}
        r={12}
        d='M37.004 97h8M41 93.001v8'
      />

      <BodySelectButton
        id='o-tooth4'
        selectedKeys={selectedKeys}
        cx={37}
        cy={136}
        r={12}
        d='M33.004 136h8M37 132.001v8'
      />

      <BodySelectButton
        id='o-tooth3'
        selectedKeys={selectedKeys}
        cx={33}
        cy={184}
        r={12}
        d='M29.004 184h8M33 180.001v8'
      />

      <BodySelectButton
        id='o-tooth2'
        selectedKeys={selectedKeys}
        cx={29}
        cy={237}
        r={12}
        d='M25.004 237h8M29 233.001v8'
      />

      <BodySelectButton
        id='o-tooth1'
        selectedKeys={selectedKeys}
        cx={27}
        cy={290}
        r={12}
        d='M23.004 290h8M27 286.001v8'
      />
    </svg>
  );
};
export default DentalUpperButtons;
